import CurrencyNumber from "app/components/CurrencyNumber/CurrencyNumber";
import { DateFormatsTypes, MomentDate } from "app/components/Moment/Moment";
import { TransactionDetailsStatus } from "app/utils/const";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import "../Report.scss";

const Transactions = (props: {
  status: string;
  date: string;
  transactionId?: number;
  type: string;
  detail: string;
  amount: number;
  balance?: number;
}) => {
  const [displayPendingTransaction, setDisplayPendingTransaction] =
    useState(false);

  useEffect(() => {
    if (
      props.status.toUpperCase() === TransactionDetailsStatus.NEW ||
      props.status.toUpperCase() === TransactionDetailsStatus.PENDING_APPROVAL
    ) {
      setDisplayPendingTransaction(true);
    }
  }, [displayPendingTransaction]);

  return (
    <div className="report">
      <div className="report__content report__content__transactions">
        <div className="report__content__column">
          <div className="report__content__date">
            <MomentDate
              value={props.date}
              dateFormat={DateFormatsTypes.DATE_DDMMYYYY}
            />
          </div>
          <div className="report__content__text--light">
            <MomentDate
              value={props.date}
              dateFormat={DateFormatsTypes.TIME_HHmm}
            />
          </div>
          <br />
          <div className="report__content__transactionId">
            <span>ID: </span> {props.transactionId}
          </div>
          <div className="report__content__type">
            {props.type}{" "}
            {displayPendingTransaction && (
              <span className="display-pending-transactions">
                {" "}
                -{" "}
                <FormattedMessage
                  tagName="span"
                  id="cashier-deposit-transaction-pending"
                />
              </span>
            )}
          </div>
          <div className="report__content__text--light">{props.detail}</div>
        </div>
        <div className="report__content__column report__content__column--right">
          <div className="report__content__amount">
            <CurrencyNumber value={props.amount} minimumFractionDigits={2} />
          </div>
          {props.balance ? (
            <div className="report__content__text--light">
              <FormattedMessage tagName="span" id="reports-balance" />
              <CurrencyNumber value={props.balance} minimumFractionDigits={2} />
            </div>
          ) : (
            <div className="report__content__text--light">&nbsp;</div>
          )}
          <br />
        </div>
      </div>
    </div>
  );
};

export default Transactions;
